'use client';

import React from 'react';
import { YouTubeEmbed } from '@next/third-parties/google';

export default function YouTubeVideo({
  videoid, // Required: Your YouTube video ID.
  playlabel = 'Play video', // Optional: A visually hidden label for the play button for accessibility.
  params = '', // Optional: Video player parameters as a query string (e.g., "controls=0&start=10").
  ...props // Optional: Any other props you want to pass to the YouTubeEmbed component.
}) {
  return (
    <YouTubeEmbed
      videoid={videoid}
      playlabel={playlabel}
      params={params}
      {...props}
    />
  );
}
